<template>
  <div
    class="app-dialer-call-controls"
    :class="{ [`is-${size}`]: true }"
  >
    <base-icon-button
      v-if="hasKeypadButton"
      icon="dialpad"
      :is-active="isKeypadActive"
      :is-disabled="isConnecting"
      :size="size"
      @click="$emit('toggle-keypad', $event)"
    />

    <base-icon-button
      v-if="hasInviteButton"
      icon="add"
      :is-active="isInviteButtonActive"
      :is-disabled="isConnecting"
      :size="size"
      @click="$emit('toggle-invite', $event)"
    />

    <base-icon-button
      v-if="hasTransferButton"
      icon="wrap_text"
      :is-active="isTransferButtonActive"
      :is-disabled="isConnecting"
      :size="size"
      @click="$emit('toggle-transfer', $event)"
    />

    <base-icon-button
      v-if="hasHoldButton"
      :icon="putOnHoldIcon"
      :is-active="isOnHold"
      :is-loading="isPutOnHoldActionLoading"
      :is-disabled="(isConnecting || !hasContactMemberOnCall) && !isOnHold"
      :size="size"
      @click="$emit('put-on-hold', $event)"
    />

    <base-icon-button
      v-if="hasMuteButton"
      :icon="muteIcon"
      :is-active="isMuted"
      :size="size"
      @click="$emit('mute-self', $event)"
    />

    <base-icon-button
      icon="call_end"
      color="error"
      :is-loading="isHangUpActionLoading"
      :size="size"
      @click="$emit('hang-up', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { BaseIconButton } from '@/modules/agent-picker';
import { SIZE_PROP } from '../../constants';

export default defineComponent({
  name: 'AppDialerCallControls',
  components: {
    BaseIconButton,
  },
  props: {
    isOnHold: Boolean,
    isMuted: Boolean,
    isPutOnHoldActionLoading: Boolean,
    isHangUpActionLoading: Boolean,
    isKeypadActive: Boolean,
    isInviteButtonActive: Boolean,
    isTransferButtonActive: Boolean,
    isConnecting: Boolean,
    hasKeypadButton: {
      type: Boolean,
      default: true,
    },
    hasInviteButton: {
      type: Boolean,
      default: true,
    },
    hasTransferButton: {
      type: Boolean,
      default: true,
    },
    hasHoldButton: {
      type: Boolean,
      default: true,
    },
    hasMuteButton: {
      type: Boolean,
      default: true,
    },
    hasContactMemberOnCall: Boolean,
    size: SIZE_PROP,
  },
  emits: [
    'toggle-keypad',
    'toggle-invite',
    'toggle-transfer',
    'put-on-hold',
    'mute-self',
    'hang-up',
  ],
  computed: {
    muteIcon(): string {
      return this.isMuted ? 'mic_off' : 'mic';
    },
    putOnHoldIcon(): string {
      return this.isOnHold ? 'phone' : 'phone_paused';
    },
  },
});
</script>

<style lang="scss" scoped>
.app-dialer-call-controls {
  --controls-columns-gap: 1rem;
  --controls-row-gap: 1rem;

  display: flex;
  justify-content: center;
  column-gap: var(--controls-columns-gap);
  row-gap: var(--controls-row-gap);

  &.is-mobile {
    --controls-columns-gap: 2rem;

    flex-wrap: wrap;
    /* Max 3 buttons in a row */
    max-width: 14.5rem;
  }
}
</style>
